(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    class HeaderSearch extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.header-search__toggle');
      this.panel = this.querySelector('.header-search__panel');
      this.input = this.querySelector('.header-search__input');
      this.toggle?.addEventListener('click', this.onToggle);
      document.addEventListener('keydown', this.onDocumentKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggle);
      document.removeEventListener('keydown', this.onDocumentKeydown);
      document.removeEventListener('click', this.onDocumentClick);
    }

    onToggle = () => {
      this.toggleOpen(!this.hasAttribute('open'));
    };

    toggleOpen(open) {
      this.toggle?.setAttribute('aria-expanded', String(open));

      if (this.panel) {
        this.panel.hidden = !open;
      }

      if (open) {
        this.setAttribute('open', '');
        this.input?.focus();
        return;
      }

      this.removeAttribute('open');
    }

    onDocumentKeydown = (event) => {
      if (event.key !== 'Escape' || !this.hasAttribute('open')) return;

      this.toggleOpen(false);
      this.toggle?.focus();
    };

    onDocumentClick = (event) => {
      if (!this.hasAttribute('open') || this.contains(event.target)) return;

      this.toggleOpen(false);
    };
  }

  if (!customElements.get('header-search')) {
    customElements.define('header-search', HeaderSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-shop-menu"] && !Shopify.designMode) return;
  try {
    class HeaderMegaMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-mega-trigger]');
      this.panel = this.querySelector('[data-mega-panel]');
      this.addEventListener('mouseenter', this.open);
      this.addEventListener('mouseleave', this.close);
      this.trigger?.addEventListener('focus', this.open);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.open);
      this.removeEventListener('mouseleave', this.close);
      this.trigger?.removeEventListener('focus', this.open);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
    }

    open = () => {
      if (!this.panel) return;

      this.panel.hidden = false;
      this.setAttribute('open', '');
      this.trigger?.setAttribute('aria-expanded', 'true');
    };

    close = () => {
      if (!this.panel) return;

      this.panel.hidden = true;
      this.removeAttribute('open');
      this.trigger?.setAttribute('aria-expanded', 'false');
    };

    onFocusOut = (event) => {
      if (this.contains(event.relatedTarget)) return;

      this.close();
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape' || !this.hasAttribute('open')) return;

      event.preventDefault();
      this.close();
      this.trigger?.focus();
    };

    onDocumentClick = (event) => {
      if (!this.hasAttribute('open') || this.contains(event.target)) return;

      this.close();
    };
  }

  if (!customElements.get('header-mega-menu')) {
    customElements.define('header-mega-menu', HeaderMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-toggle"] && !Shopify.designMode) return;
  try {
    class ThemeToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.labelLight = this.dataset.labelLight || '';
      this.labelDark = this.dataset.labelDark || '';
      this.sync();
      this.button?.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
    }

    get theme() {
      return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
    }

    onClick = () => {
      this.setTheme(this.theme === 'light' ? 'dark' : 'light');
    };

    setTheme(theme) {
      document.documentElement.setAttribute('data-theme', theme);

      try {
        localStorage.setItem('dnax-theme', theme);
      } catch (error) {}

      this.sync();
    }

    sync() {
      const light = this.theme === 'light';

      if (!this.button) return;

      this.button.setAttribute('aria-label', light ? this.labelDark : this.labelLight);
      this.button.setAttribute('aria-pressed', String(light));
    }
  }

  if (!customElements.get('theme-toggle')) {
    customElements.define('theme-toggle', ThemeToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
